"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubTeam = exports.getMemberInfoData = exports.getMemberListPageData = exports.getMemberListData = exports.getTeamListData = exports.updataMemberListLoading = exports.updateMemberListTotal = exports.updateMemberListPageNo = exports.updateAddressTree = exports.updateSingleMemberInMemberList = exports.updateMemberInfo = exports.updateMemberListPage = exports.updateMemberList = exports.updateSelectedTeamInfo = exports.updateTeamList = void 0;
const api_1 = require("../../../../exports/api");
const actions = __importStar(require("../../../shared/store/action_constants"));
const config_1 = require("../../../../config");
function updateTeamList(teamList) {
    return {
        type: actions.UPDATE_TEAM_LIST,
        payload: teamList,
    };
}
exports.updateTeamList = updateTeamList;
function updateSelectedTeamInfo(info) {
    return {
        type: actions.UPDATE_SELECTED_TEAM_INFO,
        payload: info,
    };
}
exports.updateSelectedTeamInfo = updateSelectedTeamInfo;
function updateMemberList(memberList) {
    return {
        type: actions.UPDATE_MEMBER_LIST,
        payload: memberList,
    };
}
exports.updateMemberList = updateMemberList;
function updateMemberListPage(memberList) {
    return {
        type: actions.UPDATE_MEMBER_LIST_PAGE,
        payload: memberList,
    };
}
exports.updateMemberListPage = updateMemberListPage;
function updateMemberInfo(memberInfo) {
    return {
        type: actions.UPDATE_MEMBER_INFO,
        payload: memberInfo,
    };
}
exports.updateMemberInfo = updateMemberInfo;
function updateSingleMemberInMemberList(memberInfo) {
    return {
        type: actions.UPDATE_SINGLE_MEMBER_IN_MEMBERLIST,
        payload: memberInfo,
    };
}
exports.updateSingleMemberInMemberList = updateSingleMemberInMemberList;
function updateAddressTree(parentId, childrenTree) {
    return {
        type: actions.UPDATE_ADDRESS_TREE,
        payload: { parentId, childrenTree },
    };
}
exports.updateAddressTree = updateAddressTree;
function updateMemberListPageNo(pageNo) {
    return {
        type: actions.UPDATE_MEMBER_LIST_PAGE_NO,
        payload: pageNo,
    };
}
exports.updateMemberListPageNo = updateMemberListPageNo;
function updateMemberListTotal(total) {
    return {
        type: actions.UPDATE_MEMBER_LIST_TOTAL,
        payload: total,
    };
}
exports.updateMemberListTotal = updateMemberListTotal;
function updataMemberListLoading(loading) {
    return {
        type: actions.UPDATE_MEMBER_LIST_LOADING,
        payload: loading,
    };
}
exports.updataMemberListLoading = updataMemberListLoading;
/**
 * Contacts - get Team(Departments) Lists
 */
function getTeamListData(_user) {
    let teamList = [];
    return (dispatch) => {
        api_1.Api.getTeamListLayered().then(res => {
            var _a;
            const { success, data } = res.data;
            if (success) {
                teamList = data;
            }
            dispatch(updateTeamList(teamList));
            const firstTeamId = (_a = teamList === null || teamList === void 0 ? void 0 : teamList[0]) === null || _a === void 0 ? void 0 : _a.teamId;
            if (!firstTeamId)
                return;
            api_1.Api.readTeam(firstTeamId).then(res => {
                const { success, data } = res.data;
                success && dispatch(updateSelectedTeamInfo({
                    teamTitle: data.teamName,
                    memberCount: data.memberCount,
                    teamId: data.teamId,
                }));
                dispatch(updateMemberInfo({ memberId: '', email: '' }));
            }, err => {
                console.error('API.readTeam error', err);
            });
        }, err => {
            console.error('API.getTeamListLayered error', err);
        });
    };
}
exports.getTeamListData = getTeamListData;
/**
 * Contacts - get specified Team(Departments) members list
 */
function getMemberListData(teamId) {
    const pageObjectParams = {
        pageSize: config_1.ConfigConstant.MEMBER_LIST_PAGE_SIZE,
        order: ' vom.id',
        sort: config_1.ConfigConstant.SORT_ASC,
    };
    return (dispatch) => {
        dispatch(updataMemberListLoading(true));
        api_1.Api.getMemberListInSpace(JSON.stringify(Object.assign(Object.assign({}, pageObjectParams), { pageNo: 1 })), teamId).then(res => {
            const { success, data } = res.data;
            if (success) {
                const memberListInSpace = data.records;
                const memberTotal = data.total;
                dispatch(updateMemberListTotal(memberTotal));
                dispatch(updateMemberList(memberListInSpace));
                dispatch(updataMemberListLoading(false));
            }
        }, err => {
            console.error('API.getMemberListInSpace error', err);
        });
    };
}
exports.getMemberListData = getMemberListData;
function getMemberListPageData(pageNo, teamId) {
    const pageObjectParams = {
        pageSize: config_1.ConfigConstant.MEMBER_LIST_PAGE_SIZE,
        order: ' vom.id',
        sort: config_1.ConfigConstant.SORT_ASC,
    };
    return (dispatch) => {
        dispatch(updataMemberListLoading(true));
        api_1.Api.getMemberListInSpace(JSON.stringify(Object.assign(Object.assign({}, pageObjectParams), { pageNo })), teamId).then(res => {
            const { success, data } = res.data;
            if (success) {
                const memberListInSpace = data.records;
                const memberTotal = data.total;
                dispatch(updateMemberListTotal(memberTotal));
                dispatch(updateMemberListPage(memberListInSpace));
                dispatch(updataMemberListLoading(false));
            }
        }, err => {
            console.error('API.getMemberListInSpace error', err);
        });
    };
}
exports.getMemberListPageData = getMemberListPageData;
/**
 * Contacts - get specified member detail info
 */
function getMemberInfoData(memberId) {
    return (dispatch) => {
        api_1.Api.getMemberInfo({ memberId }).then(res => {
            const { success, data } = res.data;
            if (success) {
                dispatch(updateMemberInfo(data));
            }
        }, err => {
            console.error('API.getMemberInfo error', err);
        });
    };
}
exports.getMemberInfoData = getMemberInfoData;
const getSubTeam = (teamId) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        const subTree = yield api_1.Api.getSubTeams(teamId);
        dispatch(updateAddressTree(teamId, subTree.data.data));
    });
};
exports.getSubTeam = getSubTeam;
//# sourceMappingURL=address_list.js.map